import { BrandingTemplate } from "../../entity/model/branding-template";

export const DEFAULT_BRANDING_TEMPLATES: BrandingTemplate[] = [
    {
        id: 'default',
        name: 'Default Template',
        companyName: 'Zitles Title Services',
        companyAddress: '123 Business Ave\nCharleston, SC 29401',
        phone: '(843) 555-0123',
        email: 'billing@zitles.com',
        website: 'www.zitles.com',
        footerText: 'Thank you for choosing Zitles Title Services!',
    }
]; 